if(typeof window === 'object')
    window.franklyDataLayer = window.franklyDataLayer || [];

function reportError(e){
  if(typeof window !== 'object' )
    return
  console.error('GNM: %s', e.message)
  window.franklyDataLayer.push({
    event: 'gnm.error',
    message: e.message,
    fileName: e.fileName,
    lineNumber: e.lineNumber

  })
}


export default{
  reportError
}



// WEBPACK FOOTER //
// ./app/components/custom/ssr/Analytics.js